import { ts } from '@/plugins/i18nFormat'

const handicapSystems = [null, 'zadar', 'texel', 'RsT', 'RsA', 'pynumber', 'pylist', 'HaBr']

const handicapLists: Record<string, Record<string, number>> = {
    'pylist': {
        '4000': 926,
        '420': 1110,
        '470': 973,
        '505': 892,
        '2000': 1122,
        '2.4mR': 1235,
        '29er': 900,
        '49er': 697,
        '49erFX': 720,
        'Albacore': 1037,
        'Alto': 910,
        'B14': 858,
        'Blaze': 1030,
        'British Moth': 1160,
        'Byte CII': 1123,
        'Buzz': 1009,
        'Comet': 1208,
        'Comet Xtra': 1210,
        'Comet Trio Mk 1': 1082,
        'Comet Trio Mk 2': 1053,
        'Contender': 973,
        'Devoti D-One': 957,
        'Devoti D-Zero': 1029,
        'Enterprise': 1137,
        'Europe / Evropa': 1140,
        'Finn': 1049,
        'Fireball': 960,
        'Firefly': 1178,
        'Flying Fifteen (Classic)': 1079,
        'Flying Fifteen (Silver)': 1051,
        'Flying Fifteen': 1028,
        'Flying Dutchman': 879,
        'GP 14': 1145,
        'Graduate': 1110,
        'Gull': 1385,
        'Hadron H2': 1045,
        'Hornet': 950,
        'ILCA 4': 1218,
        'ILCA 6': 1156,
        'ILCA 7': 1103,
        'Illusion': 1285,
        'K1': 1060,
        'K6': 900,
        'Kestrel': 1042,
        'Lark': 1060,
        'Laser 2000': 1107,
        'Laser II': 1085,
        'Laser Pico': 1330,
        'Laser SB20': 911,
        'Laser Stratos': 1108,
        'Laser EPS': 1033,
        'Lightning 368': 1171,
        'Megabyte': 1058,
        'Melges 15': 994,
        'Melges 20': 925,
        'Melges 24': 846,
        'Merlin Rocket': 980,
        'Miracle': 1196,
        'Mirror (D/H)': 1364,
        'Mirror (S/H)': 1364,
        'Musto Skiff': 830,
        'National 12': 1070,
        'OK': 1092,
        'Optimist': 1629,
        'Osprey': 932,
        'Phantom': 998,
        'Raceboard': 1000, /* nasel jsem, ze za busaku je rychly jako 29er, ale jezdi rychlostne bliz k Vareu */
        'Rooster 8.1': 1016,
        'RS Aero 5': 1141,
        'RS Aero 6': 1098,
        'RS Aero 7': 1062,
        'RS Aero 9': 1005,
        'RS Elite': 938,
        'RS Feva S': 1280,
        'RS Feva XL': 1248,
        'RS Neo': 1147,
        'RS Quba': 1295,
        'RS Quest': 1130,
        'RS Tera PRO': 1368,
        'RS Tera Sport': 1452,
        'RS Vareo': 1095,
        'RS Venture': 1092,
        'RS Vision': 1150,
        'RS Zest': 1228,
        'RS100 8.4': 1002,
        'RS100 10.2': 981,
        'RS200': 1053,
        'RS200 No Spinnaker': 1065,
        'RS300': 965,
        'RS400': 945,
        'RS500': 963,
        'RS600': 921,
        'RS600 FF': 550,
        'RS700': 845,
        'RS800': 797,
        'RS900': 750,
        'Scorpion': 1042,
        'Seafly': 1074,
        'Splash': 1247,
        'Snipe': 1104,
        'Solo': 1139,
        'Star': 917,
        'Solution': 1112,
        'Streaker': 1121,
        'Supernova': 1075,
        'Tasar': 1022,
        'Topaz Argo': 1075,
        'Topaz Duo': 1190,
        'Topaz Magno': 1175,
        'Topaz Omega': 1075,
        'Topaz Uno': 1251,
        'Topaz Vibe': 1185,
        'Topaz Xenon': 1100,
        'Topper': 1369,
        'Topper 4.2': 1450,
        'Vaurien': 1140,
        'Vortex': 950,
        'Waszp': 620,
        'Wanderer': 1201,
        'Wayfarer': 1107,
        'Blaze Fire': 1050,
        'Byte CI': 1223,
        'Cadet': 1455,
        'Devoti D-Zero Black rig': 1051,
        'Fusion Pro': 1281,
        'Fusion Pro Gen': 1275,
        'International Canoe': 858,
        'Mirror No Spinnaker': 1376,
        'Hansa 303 (S/H)': 1570,
        'Hansa Liberty': 1411,
        'Tornado': 637,
        'A Class': 695,
    },
    'RsT': {
        'RS Tera Sport': 1452,
        'RS Tera PRO': 1368,
    },
    'RsA': {
        'RS Aero 5': 1070,
        'RS Aero 6': 1040,
        'RS Aero 7': 1000,
        'RS Aero 9': 960,
    },
    'HaBr': {
        'Melges 24 (genaker)': 528,
        'Seascape 27 (genaker)': 534,
        'Melges 20 (genaker)': 552,
        'Laser SB20 (genaker)': 576,
        'Cafe 24 R (genaker)': 582,
        'Hobie Open 5.70 (genaker)': 606,
        'Seascape 18 (genaker)': 618,
        'Limbo 6.6 D (spinaker)': 618,
        'Saffier Sc 8m Open (code zero)': 672,
        'Beneteau First 211 (spinaker)': 672,
        'Hunter Formula One (spinaker)': 675,
        'Limbo 6.6 (spinaker)': 678,
        'Laser Stratos (spinaker)': 681,
        'Saffier Sc 8m Open (white sails)': 672,
        'Beneteau First 211 (white sails)': 672,
        'Jeanneau Tonic 23 (white sails)': 678,
        'Dehler Dehlya 22 (white sails)': 678,
        'Limbo 6.6 (white sails)': 678,
        'Northman Maxus 22 (white sails)': 681,
        'Viva 700 (white sails)': 684,
        'Beneteau First 18 XL (white sails)': 690,
        'Dehler Delanta 760 (white sails)': 696,
        'Bavaria 606 (white sails)': 696,
        'Dalpol Phobos 21 (white sails)': 713,
        'Corvette 650 (white sails)': 717,
        'Marcon Striker 22 (white sails)': 720,
        'Viko 550 (white sails)': 720,
        'Juno (white sails)': 720,
        'Musketyr (white sails)': 720,
        'Zeton (white sails)': 726,
        'Miton 23 (white sails)': 732,
        'Neptun 20 (white sails)': 738,
        'Avar 17 (white sails)': 750,
    },
}

const defaultHandicap: Record<string, string> = {
    'pynumber': '1000',
    'zadar': '1',
    'texel': '100',
    'pylist': 'Optimist',
    'RsT': 'RS Tera Sport',
    'RsA': 'RS Aero 7',
    'HaBr': 'Seascape 18 (genaker)',
}

export function allHandicapSystems() {
    return handicapSystems
        .map((system) => ({
            value: system,
            label: ts(system === null ? 'handicapSystem-none' : 'handicapSystem-' + system),
        }))
        .sort((a, b) => a.value === null ? -1 : (b.value === null ? 1 : a.label.localeCompare(b.label)))
}

export function allHandicaps(system: string) {
    return Object.hasOwn(handicapLists, system)
        ? Object.entries(handicapLists[system])
            .map((item) => ({ value: item[1], label: item[0] }))
            .sort((a, b) => a.label.localeCompare(b.label))
        : null
}

export function getDefaultHandicap(system: string) {
    return defaultHandicap[system] ?? ''
}

export const handicapBaseDate = '2022-01-01'
